import React from 'react';
import { useParams } from 'react-router-dom';

/**
 * Higher-Order Component that injects route parameters into the wrapped component
 * @param {React.ComponentType} WrappedComponent - The component to wrap
 * @returns {React.FC} A new component with params prop injected
 */
export function withParams(WrappedComponent) {
  /**
   * Component that wraps the original component with route params
   * @param {Object} props - Props passed to the component
   * @returns {JSX.Element} Wrapped component with injected params
   */
  return function WithParamsComponent(props) {
    const params = useParams();
    return <WrappedComponent {...props} params={params} />;
  };
} 